import type { EditorCore } from "@loumy/contracts";
import { platformer2dCore } from "@loumy/editor-platformer-2d";
import { demoBoardCore } from "./demo-board";

// D66 — zentrale Editor-Core-Liste (analog packages/tools/src/index.ts → ALL_TOOL_CORES).
// Ein Editor = ein Modul/Paket-Eintrag hier + eine Zeile in dieser Liste + (Frontend) eine Zeile in
// EDITOR_UI_LOADERS. „Nichts referenziert einen Editor hart" (§1/§5-Analogon). Der 2D-Platformer (D75)
// ist ein eigenes Paket (@loumy/editor-platformer-2d) — Achse A, hier nur registriert.

export {
  demoBoardCore,
  DemoBoardDoc,
  DemoBoardNode,
  DEMO_TOOLS,
  type DemoBoardUi,
  type DemoTool,
} from "./demo-board";
export { platformer2dCore } from "@loumy/editor-platformer-2d";

export const ALL_EDITOR_CORES: EditorCore[] = [demoBoardCore, platformer2dCore];
